module.exports = __webpack_public_path__ + "img/logo-samsung@3x.5e2c7b37.png";